import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GruposPErmisosService } from 'app/services/configuracion/grupos-permisos.service';

@Component({
  selector: 'app-grupos-permisos',
  templateUrl: './grupos-permisos.component.html',
  styleUrls: ['./grupos-permisos.component.scss']
})
export class GruposPermisosComponent implements OnInit {

  displayedColumns: string[] = ['idGrupo', 'nombre', 'ver'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;

  public categorias: any = [];

  constructor(private catalogoservice: GruposPErmisosService) { }

  ngOnInit(): void {
    this.obtenerCategorias()
  }

  obtenerCategorias = () =>{
    this.catalogoservice.getGruposPermisos().subscribe(response =>{
      this.categorias = response;
      this.dataSource = new MatTableDataSource(this.categorias);
      this.dataSource.sort = this.sort;
    });
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
